import clsx from 'clsx';
import { SharedButtonProps } from '../../types';

export default function SharedButton({
  id,
  children,
  onClick,
  isActive = false,
  className = '',
  type = 'button',
  size = 'sm',
  variant = 'primary',
  iconLeft,
  iconRight,
  disabled = false,
  arrow = 'none',
  style = {},
}: SharedButtonProps) {
  const baseStyles =
    'inline-flex items-center font-medium rounded-md transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2';

  const sizeStyles = {
    xs: 'text-xs px-2 py-1',
    sm: 'text-sm px-2 py-1 ml-2',
    md: 'text-base px-4 py-2 ml-2',
    lg: 'text-lg px-5 py-3 ml-2',
  }[size];

  const variantStyles = {
    primary: isActive ? 'bg-pink text-white' : 'bg-blue text-white hover:bg-blue-700',
    secondary: isActive ? 'bg-pink text-white' : 'bg-gray-secondary text-black hover:bg-gray-200',
    outline: isActive
      ? 'border border-blue-600 text-blue-600 bg-blue-50'
      : 'border border-gray-300 text-gray-800 bg-white hover:bg-gray-100',
    danger: isActive ? 'bg-red-700 text-white' : 'bg-red-600 text-white hover:bg-red-700',
  }[variant];

  const arrowIcon =
    arrow === 'up' ? (
      <i className="fa fa-angle-up ml-2 opacity-60" />
    ) : arrow === 'down' ? (
      <i className="fa fa-angle-down ml-2 opacity-60" />
    ) : null;

  return (
    <button
      id={id}
      type={type}
      onClick={onClick}
      disabled={disabled}
      style={style}
      className={clsx(
        baseStyles,
        sizeStyles,
        variantStyles,
        disabled && 'opacity-50 cursor-not-allowed',
        className,
      )}
    >
      {iconLeft && <span className="mr-2">{iconLeft}</span>}
      {children}
      {iconRight && <span className="ml-2">{iconRight}</span>}
      {arrowIcon}
    </button>
  );
}
